var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('strong',[_vm._v(_vm._s(_vm.timeLimit("dd.MM.yyyy")))]),_c('br'),_vm._v(" "+_vm._s(_vm.timeLimit("HH:mm"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }